/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from 'react';
import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';
import useAuthState from '@/states/auth.state';
import { keycloakAuth } from '@/utils/auth/keycloak';

export default function useWebSocket(userData: any, onNotification: any, onTaskCount: any) {
  const stompClientRef = useRef<Client | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const { keycloakUserInfo } = useAuthState.getState();

  useEffect(() => {
    const fetchToken = async () => {
      const t = await keycloakAuth.getValidToken();
      setToken(t ?? null);
    };
    fetchToken();
  }, []);

  useEffect(() => {
    console.log('Setting up WebSocket connection...');
    if (!keycloakUserInfo?.email) return;
    if (!token) return; // Wait for token to be fetched
    console.log('retrieved user email:', keycloakUserInfo.email);
    const encodedUsername = encodeURIComponent(keycloakUserInfo.email); // hasil: anita%40javan.ci.id

    const socket = new SockJS(`https://onprem.merapi.alurkerja.com/api/v1/notifws/ws?username=${encodedUsername}&app=studio&token=${token}`);

    const stompClient = new Client({
      webSocketFactory: () => socket,
      debug: str => console.info('[STOMP]', str),
      onConnect: () => {
        console.info('✅ Connected to WebSocket');

        // Subscribe notifikasi pribadi
        stompClient.subscribe(`/user/queue/notifications`, msg => {
          const payload = msg.body;
          onNotification?.(payload);
        });

        // Subscribe jumlah task pribadi
        stompClient.subscribe('/user/queue/task_count', msg => {
          const payload = msg.body;
          onTaskCount?.(payload);
        });
      },
      reconnectDelay: 1000, 

      onDisconnect: () => {
        console.log('🔌 Koneksi WebSocket terputus');
      },

      onWebSocketClose: (evt) => {
        console.warn("🛑 WebSocket closed:", evt);
      },

      onWebSocketError: (evt) => {
        console.error("❌ WebSocket error:", evt);
      },

      onStompError: (frame) => {
        console.error("❌ STOMP error:", frame);
      },
      
      heartbeatIncoming: 1000,
      heartbeatOutgoing: 1000,

    });
    

    stompClient.activate();
    stompClientRef.current = stompClient;

    return () => {
      stompClientRef.current?.deactivate();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keycloakUserInfo?.email, token]);
}
